// extracted by mini-css-extract-plugin
module.exports = {"heading":"style_heading__N7Az2"};